export const SoftwareItems = [
    {
        name: 'Java',
        image: 'java.png',
    },
    {
        name: 'Python',
        image: 'python.png',
    },
    {
        name: "TypeScript",
        image: "ts.png"
    },
    {
        name: 'C',
        image: 'c-programming.png',
    },
    {
        name: 'C++',
        image: 'cpp.png',
    },
    {
        name: 'Django',
        image: 'django.jpg',
    },
    {
        name: 'PyTorch',
        image: 'pytorch.png',
    },
    {
        name: 'PostgreSQL',
        image: 'postgres.png',
    },
    {
        name: 'Psycopg2',
        image: 'psycopg2.png',
    },
    {
        name: 'React.js',
        image: 'reactnative.png',
    },
    {
        name: 'Firebase',
        image: 'firebase.png',
    },
    {
        name: 'Vue.js',
        image: 'vuejs.png',
    },
    {
        name: 'JavaScript',
        image: 'javascript.png',
    },
    {
        name: 'React Native',
        image: 'reactnative.png',
    },
    {
        name: 'HTML 5',
        image: 'html.png',
    },
    {
        name: 'CSS 3',
        image: 'css.png',
    },
    {
        name: 'NoSQL',
        image: 'nosql.png',
    },
    {
        name: 'R',
        image: 'r-stats.png',
    },
    {
        name: 'Android Dev',
        image: 'android-dev.png',
    },
    {
        name: 'Linux CLI',
        image: 'linux.png',
    },
    {
        name: 'Git',
        image: 'git.png',
    },
];